
import HomePage from '../pages/home-page';
import Products from '../pages/products/list';
import Recruitment from '../pages/Recruitment/Index';
import ConfigurableProducts from '../pages/configurableProducts/Index';

export const routes = [
    {
        name: 'home',
        path: '/Landing/Brands',
        component: HomePage,
        display: 'Home'
    },
    {
        name: 'recruitment',
        path: '/Recruitment',
        component: Recruitment,
        display: 'Recruitment'
    },
    {
        name: 'products',
        path: '/category/:id',  
        component: Products,
        display: 'products',
        props: (route) => ({ query: route.query.q }),
    },
    {
        name: 'configurableProducts',
        path: '/PCCustomize/ConfigurableProducts/:id',
        component: ConfigurableProducts,
        display: 'ConfigurableProducts',
        props: (route) => ({ query: route.query.q }),

    }
];